/* ============================================================
   Landing Collar de Feromonas (gato + perro) -- Petmedellin
   Asset del tema. Subir en: Editar codigo > Assets > Agregar
   CONFIGURACION editable: ver WA_NUMBER mas abajo.
   ============================================================ */
(function(){
  "use strict";
  var root = document.getElementById('pm-lp');
  if(!root) return;

  /* ===== CONFIGURACION -- REEMPLAZAR SI CAMBIA ===== */
  var WA_NUMBER = '573232333670';          // WhatsApp de Petmedellin
  var SHOP      = 'https://petmedellin.com';
  var PRODUCT_URL = {
    gato:  '/products/collar-de-feromonas-para-gato-efecto-calmante',
    perro: '/products/collar-de-feromonas-perro-calming'
  };
  /* ================================================ */

  var isShopify = /petmedellin\.com$/.test(location.hostname);
  var pet = 'gato';

  function fmt(n){
    return '$' + n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  function selectedInput(){
    return root.querySelector('input[name="pm-variant-' + pet + '"]:checked');
  }

  /* ---- Cantidad: lee, valida (1-20) y corrige el input ---- */
  function getQty(){
    var input = root.querySelector('[data-qty-input]');
    if(!input) return 1;
    var v = parseInt(input.value, 10);
    if(!v || v < 1) v = 1;
    if(v > 20) v = 20;
    input.value = v;
    return v;
  }

  /* ---- Sincroniza precios, textos y enlaces segun la seleccion ---- */
  function sync(){
    var input = selectedInput();
    if(!input) return;

    var price = parseInt(input.dataset.price, 10);
    var was   = parseInt(input.dataset.was, 10);
    var off   = input.dataset.off;
    var days  = price === 39900 ? 30 : 60;

    root.querySelectorAll('[data-price-now],[data-price-now-2],[data-price-now-3]')
        .forEach(function(el){ el.textContent = fmt(price); });
    root.querySelectorAll('[data-price-was]')
        .forEach(function(el){ el.textContent = fmt(was); });
    root.querySelectorAll('[data-price-off]')
        .forEach(function(el){ el.textContent = '-' + off + '%'; });
    root.querySelectorAll('[data-price-day]')
        .forEach(function(el){ el.textContent = fmt(Math.round(price / days)); });
    root.querySelectorAll('[data-days-now]')
        .forEach(function(el){ el.textContent = days; });
    root.querySelectorAll('[data-pet-word]')
        .forEach(function(el){ el.textContent = pet; });

    // Estado visual de las opciones
    root.querySelectorAll('.pm-opt').forEach(function(opt){
      var i = opt.querySelector('input');
      opt.dataset.active = i && i.checked ? 'true' : 'false';
    });

    // Cantidad y total
    var qty = getQty();
    var total = price * qty;
    root.querySelectorAll('[data-qty-total]').forEach(function(el){
      el.textContent = qty > 1 ? ('Total (' + qty + ' unidades): ' + fmt(total)) : ('Total: ' + fmt(total));
    });

    // Enlaces de WhatsApp con mensaje prellenado
    var msg = 'Hola! Me interesa el Collar de Feromonas para ' +
              (pet === 'gato' ? 'gato' : 'perro') + ' (' + days + ' d\u00edas)' +
              (qty > 1 ? ', ' + qty + ' unidades. ' : '. ') +
              '\u00bfMe ayudan con el pedido?';
    var waUrl = 'https://wa.me/' + WA_NUMBER + '?text=' + encodeURIComponent(msg);
    root.querySelectorAll('[data-wa]').forEach(function(a){ a.href = waUrl; });
  }

  /* ---- Cambio de mascota ---- */
  function setPet(next){
    pet = next;
    root.dataset.pet = next;
    root.querySelectorAll('[data-pet-btn]').forEach(function(b){
      b.setAttribute('aria-selected', String(b.dataset.petBtn === next));
    });
    sync();
    if(window.history && history.replaceState){
      history.replaceState(null, '', '?mascota=' + next);
    }
  }

  root.querySelectorAll('[data-pet-btn]').forEach(function(btn){
    btn.addEventListener('click', function(){ setPet(btn.dataset.petBtn); });
  });
  root.querySelectorAll('.pm-opt input').forEach(function(i){
    i.addEventListener('change', sync);
  });

  /* ---- Cantidad ---- */
  var qtyInput = root.querySelector('[data-qty-input]');
  var qtyMinus = root.querySelector('[data-qty-minus]');
  var qtyPlus  = root.querySelector('[data-qty-plus]');
  if(qtyInput){
    qtyInput.addEventListener('input', sync);
    qtyInput.addEventListener('change', sync);
  }
  if(qtyMinus){
    qtyMinus.addEventListener('click', function(){
      qtyInput.value = Math.max(1, getQty() - 1);
      sync();
    });
  }
  if(qtyPlus){
    qtyPlus.addEventListener('click', function(){
      qtyInput.value = Math.min(20, getQty() + 1);
      sync();
    });
  }

  /* ---- Anadir al carrito y pasar a checkout ---- */
  root.querySelectorAll('[data-add-to-cart]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var input = selectedInput();
      if(!input) return;
      var id = input.value;
      var qty = getQty();

      // Fuera de la tienda (previsualizacion): manda a la ficha de producto
      if(!isShopify){
        window.open(SHOP + PRODUCT_URL[pet], '_blank', 'noopener');
        return;
      }

      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Agregando\u2026';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items: [{id: Number(id), quantity: qty}]})
      })
      .then(function(r){
        if(!r.ok) throw new Error('cart');
        window.location.href = '/checkout';
      })
      .catch(function(){
        // Respaldo: permalink de carrito de Shopify
        window.location.href = '/cart/' + id + ':' + qty;
      })
      .finally(function(){
        btn.disabled = false;
        btn.textContent = original;
      });
    });
  });

  /* ---- Barra sticky: aparece al pasar el hero ---- */
  var hero = root.querySelector('.pm-hero');
  var sticky = root.querySelector('.pm-sticky');
  var footer = root.querySelector('.pm-foot');
  if(hero && sticky && 'IntersectionObserver' in window){
    var visible = {hero: true, footer: false};
    var update = function(){
      sticky.dataset.show = (!visible.hero && !visible.footer) ? 'true' : 'false';
    };
    new IntersectionObserver(function(entries){
      entries.forEach(function(e){ visible.hero = e.isIntersecting; });
      update();
    }, {rootMargin: '-120px 0px 0px 0px'}).observe(hero);

    if(footer){
      new IntersectionObserver(function(entries){
        entries.forEach(function(e){ visible.footer = e.isIntersecting; });
        update();
      }).observe(footer);
    }
  }

  /* ---- Estado inicial: respeta ?mascota=perro en la URL ---- */
  var fromUrl = new URLSearchParams(location.search).get('mascota');
  setPet(fromUrl === 'perro' ? 'perro' : 'gato');
})();
